//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useCallback, useEffect, useRef, useState, } from 'react';
import dayjs from 'dayjs';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';

// === COMPONENTS ===
import { useFile } from '../../../../../FileContext/FileContext';
import Styled from 'components/Styled/Styled';
import { Header } from 'components/Collapsible';
import Doctype  from './components/Doctype/Doctype';
import Standard from './components/Standard/Standard';

// === API ===
import { emit, on, removeListener, sendMessageData } from 'api/prokey/prokey.websocket';
import useOnVisible from 'components/hooks/useOnVisible/useOnVisible';

//#endregion

//-----------------------------------------------------------------
export default function Field( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id } = props;

  const theme = useTheme();

  const { file_id } = useFile();
  
  const [ field   , setField   ] = useState({});
  const [ focused , setFocused ] = useState(false);

  const ref = useRef(null);
  const ref_input = useRef();

  const [is_visible] = useOnVisible(ref);

  //#endregion

  //#region [STYLES]


  //#endregion
    
  //#region [EFFECT]
  
  useEffect( () => {
    const FIELD = 'FILE_FIELD';
    
    //-----------------------------------------------------------------
    function handleField( data ) {
      //-----------------------------------------------------------------
      if( id !== data.id ) return;
      setField( data );
      if( !data.is_selected || ref_input.current == null ) return;
      ref_input.current.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
      ref_input.current.focus();
    }

    on( FIELD, handleField );

    return () => {
      removeListener( FIELD , handleField );
    }
  }, [id, ref_input] )

  useEffect( () => {
    if( !is_visible ) return;
    sendMessageData( 'FILE_REQUEST_FIELD', { file_id, field_id: id } );
  }, [id,is_visible] )
  
  useEffect( () => {
    if( ref_input.current == null ) return;
    //-----------------------------------------------------------------
    function handleFieldFocus(data) {
      //-----------------------------------------------------------------
      if( data == undefined && focused ) {
        ref_input.current.scrollIntoView({ behavior: "instant", block: "center", inline: "nearest" });
        ref_input.current.focus();
        return;
      }
      
      if( data == undefined ) return;

      if( data.id !== id && focused ) {
        setFocused( false );
      };
      if( data.id !== id ) return;
      setFocused( true );
      ref_input.current.focus();
    }

    const FIELD_FOCUS = 'FILE_FIELD_FOCUS';
    on( FIELD_FOCUS, handleFieldFocus );

    return () => {
      removeListener( FIELD_FOCUS, handleFieldFocus );
    }
  }, [focused, ref_input.current, id] )
  
  useEffect( () => {
  }, [field?.value] )

  //#endregion
  
  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onFocus() {
    //-----------------------------------------------------------------
    if( focused ) return;
    sendMessageData( 'FILE_FIELD_SELECT', { file_id, fields: [id], is_selected: true } )
  }

  //#endregion

  //#region

  //-----------------------------------------------------------------
  function onChange( value ) {
    //-----------------------------------------------------------------
    sendMessageData( 'FILE_FIELD_UPDATE', { file_id, field: { id, value } } )
  }

  //#endregion

  //#region [RENDER]

  const border_pd = {border: '2px solid ' + theme.palette.primary.main, borderRadius: '5px'};
  const border_orange = {border: '2px solid ' + 'orange', borderRadius: '5px'};
  const border_green  = {border: '2px solid ' + 'green' , borderRadius: '5px'};
  const _border = focused ? border_orange : border_pd;
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const header = field?.display_info?.header || (field.name||'').replace('PD','').replace('Doc', '').replaceAll('_', ' ')
    return (
      <Styled ref={ref} styles={[{minHeight:'70px'}]} >
        {
          field == null || !is_visible? (
           <div>Loading...</div> 
          ) : (
            <>
              <Header height={30} title={header} />
              <Styled styles={[{marginLeft: '2rem'},_border,{width:'calc( 100% - 4rem )',height:'32px'}]}>
                {displayContent()}
              </Styled>
              {focused ? displayHistory() : null}
            </>
          )
        }
      </Styled>
    )
  }

  //-----------------------------------------------------------------
  function displayContent() {
    //-----------------------------------------------------------------
    if( !field ) return;

    if( field.display_info?.type === 'doctype' ) {
      return <Doctype ref={ref_input} content={field?.value || ''} handleFocus={onFocus} handleChange={onChange} />
    }

    return (
      <Standard ref={ref_input} content={field?.value||''} handleFocus={onFocus} handleChange={onChange} />
    )
  }

  //-----------------------------------------------------------------
  function displayHistory() {
    //-----------------------------------------------------------------
    if( field.history?.length <= 0 ) {
      return (
      <Styled styles={[{padding:'20px'}]}>
        No field history.
      </Styled>
      )
    }
    const history = field.history?.map( (x,index)=>(
      [
        <div key={'stage-'+index}>{x.stage||''}</div>,
        <div key={'value-'+index}>{x.value||''}</div>,
        <div key={'user-' +index} >{x.user||'SYSTEM'}</div>,
        <div key={'date-' +index} >{dayjs(x.timestamp).format('YYYY-MM-DD HH:mm A')||''}</div>,
      ]
    ))||null
    return (
      <Styled styles={[{display:'grid', gridTemplateColumns: 'repeat( 3, 1fr ) auto', gridTemplateRows: `repeat( ${history.length}, 1fr )`},{padding:'20px'}]}>
        {[<div>Stage</div>,<div>Value</div>,<div>User</div>,<div>Date</div>]}
        {history}
      </Styled>
    )
  }

  //#endregion

  return display();
}